module.exports = __webpack_public_path__ + "static/img/m-b-logo.ab4dd19d.png";